import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/quickpay/apple/validate-merchant/{guid}
// This endpoint is called during Apple Pay merchant validation.
// Your backend must call Apple's validation URL and return the merchant session.
export const quickpayAppleValidateMerchant = async (
  guid: string,
  payload: { validationUrl: string }
): Promise<any> => {
  console.log('WE ARE HITTING THE API FOR QUICKPAY APPLE VALIDATE MERCHANT')
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/quickpay/apple/validate-merchant/${guid}`, Util.Obj.keysToSnake(payload))
      .then(response => {
        console.log('RESPONSE FROM QUICKPAY APPLE VALIDATE MERCHANT', response.data)
        resolve(response.data.merchantSession)
      })
      .catch(err => {
        console.error('ERROR FROM QUICKPAY APPLE VALIDATE MERCHANT', err)
        reject(new Error('Failed to validate Apple Pay merchant: ' + err))
      })
  })
}
